import { apiClient } from '@/lib/api-client';
import type {
  CreatePurchaseReturnPayload,
  DebitNote,
  DebitNoteListItem,
  PurchaseReturn,
  PurchaseReturnListItem,
  RefundDebitNotePayload,
} from './types';

function buildQuery(params: Record<string, string | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== '');
  if (entries.length === 0) return '';
  return `?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
}

/** Return to supplier + debit notes (QA PU3-005). */
export const purchaseReturnsApi = {
  list: (params: { purchase_order_id?: string; supplier_id?: string }) =>
    apiClient<PurchaseReturnListItem[]>(`/purchase-returns${buildQuery(params)}`),

  create: (payload: CreatePurchaseReturnPayload) =>
    apiClient<PurchaseReturn>('/purchase-returns', { method: 'POST', body: payload }),

  /** OWNER: stock leaves the store and the debit note is raised. */
  post: (id: string) => apiClient<PurchaseReturn>(`/purchase-returns/${id}/post`, { method: 'POST', body: {} }),

  cancel: (id: string) => apiClient<PurchaseReturn>(`/purchase-returns/${id}/cancel`, { method: 'POST', body: {} }),

  listNotes: (params: { supplier_id?: string; vendor_bill_id?: string }) =>
    apiClient<DebitNoteListItem[]>(`/debit-notes${buildQuery(params)}`),

  /** OWNER: set supplier credit off against an open bill of the same supplier. */
  applyNote: (id: string, vendorBillId: string, amount?: number) =>
    apiClient<DebitNote>(`/debit-notes/${id}/apply`, { method: 'POST', body: { vendor_bill_id: vendorBillId, ...(amount ? { amount } : {}) } }),

  /** OWNER: the supplier paid the remaining credit back. */
  refundNote: (id: string, payload: RefundDebitNotePayload) =>
    apiClient<DebitNote>(`/debit-notes/${id}/refund`, { method: 'POST', body: payload }),
};
